export default "__VITE_ASSET__DUEorCq2__"